const FileUpload = ({ fileInputRef, resetInputValue, handleFileSelect, type = 'imagevideo' }) => {
    return (
        <input
            hidden
            multiple
            type="file"
            ref={fileInputRef}
            accept=".mp4,.mov,.x-m4v,.png,.jpeg,.jpg"
            onClick={resetInputValue}
            onChange={e => handleFileSelect(e, type)}
        />
    );
};

export default FileUpload;
